import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import { IPodiumDTO, IPodiumDAO, IPodiumUpdateRequestParams, IPodiumLink } from '../podium.dao';
import { IMeetingConnectionRequestParams } from '../connections.dao';
import {
    MEETING_PODIUM_LINK_URL,
    MEETING_PODIUM_URL,
    PODIUM_QUESTIONS_AUDIT_LOG_CSV_URL
} from '../../constants/api/meetings-api.constants';
import { MeetingApiParams } from '../../components/_events/_manage-event/shared/connections-list/_connection-form/connection-form.viewmodel';

class PodiumDAO extends IPodiumDAO {
    constructor(
        @IoC.Inject private readonly apiClient: IApiClient
    ) {
        super();
    }

    public async getPodium(params: IMeetingConnectionRequestParams): Promise<IPodiumDTO> {
        const response = await this.apiClient.get<IPodiumDTO>(MEETING_PODIUM_URL, params);
        return response.parsedResponse;
    }

    public async createPodium(params: IMeetingConnectionRequestParams): Promise<IPodiumDTO> {
        const response = await this.apiClient.post<IPodiumDTO>(MEETING_PODIUM_URL, params);
        return response.parsedResponse;
    }

    public async updatePodium(params: IPodiumUpdateRequestParams): Promise<IPodiumDTO> {
        const response = await this.apiClient.put<IPodiumDTO>(MEETING_PODIUM_URL, params);
        return response.parsedResponse;
    }

    public async getQuestionsAuditLogCSV(params: IMeetingConnectionRequestParams): Promise<void> {
        await this.apiClient.getFile(PODIUM_QUESTIONS_AUDIT_LOG_CSV_URL, params);
    }

    public async getPodiumLink(params: MeetingApiParams): Promise<IPodiumLink> {
        const response = await this.apiClient.get<IPodiumLink>(MEETING_PODIUM_LINK_URL, params);
        return response.parsedResponse;
    }
}

export { PodiumDAO };